import { getters } from './getters';
import { actions } from './actions';
import { state } from './state';
import { mutations } from '@/store/Payment/mutations';
export const Payment = {
  namespaced: true,
  getters,
  actions,
  state,
  mutations,
};

